<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="7.25" stroke="currentColor" stroke-width="1.5"/>
<path d="M6.5 10H13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
